import React from 'react';
import SimpleCrud from '../components/SimpleCrud';

export default function PeopleNames() {
  return <SimpleCrud title="People Names" basePath="peopleNames" fields={[
    { key: 'firstName', label: 'First name' },
    { key: 'lastName', label: 'Last name' },
  ]} />;
}
